import { render } from "./WebTemplate.vue?vue&type=template&id=4b202f29"
import script from "./WebTemplate.vue?vue&type=script&lang=js"
export * from "./WebTemplate.vue?vue&type=script&lang=js"

import "./WebTemplate.vue?vue&type=style&index=0&id=4b202f29&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__